import './ProductSlider.scss';

import React, { useMemo } from 'react';
import Slider from 'react-slick';

import { BREAKPOINTS } from '@/common/constants';
import Product from '@/ebat/components/blocks/Common/Product/Product';

import {
  ProductSliderDefaultProps,
  ProductSliderPropTypes,
} from './ProductSlider.proptypes';

const ProductSlider = ({
  addToCartOptions,
  attributionToken,
  context,
  disabled,
  products,
  refetchCart,
  slidesToShow,
}) => {
  const sliderSettings = useMemo(
    () => ({
      slidesToShow,
      infinite: false,
      dots: true,
      arrows: false,
      responsive: [
        {
          breakpoint: BREAKPOINTS.large,
          settings: {
            slidesToShow: 4,
          },
        },
        {
          breakpoint: BREAKPOINTS.desktop - 1,
          settings: {
            slidesToShow,
            vertical: true,
          },
        },
        {
          breakpoint: BREAKPOINTS.tablet - 1,
          settings: {
            slidesToShow: 1,
          },
        },
      ],
    }),
    [slidesToShow],
  );

  return (
    <Slider
      className="products products--mosaic"
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...sliderSettings}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...{ 'data-qa-id': context || 'product-slider' }}
    >
      {products.map((product) => (
        <div
          className="products__item"
          data-qa-id="product-slider-item"
          key={`product-slider--${product.id}`}
        >
          <Product
            addToCartOptions={addToCartOptions}
            attributionToken={attributionToken}
            brand={product.brand}
            codeOldCompanySku={product.code_old_company_sku}
            companyAvailability={product.company_availability}
            configurations={product.configurations}
            configurator={product.configurator}
            customerPrice={product.price_and_stock?.price?.customer_price}
            disabled={disabled}
            discountPrice={product.price_and_stock?.price?.discount_price}
            exclusivity={product.exclusivity}
            flags={product.flags}
            hasPrice={product.price_and_stock?.has_price}
            hasStock={product.price_and_stock?.has_stock}
            id={product.id}
            image={product.image}
            invoiceUnit={product.price_and_stock?.invoice_unit}
            isFavorite={product.is_favorite}
            mainSku={product.main_sku}
            manufacturerSku={product.manufacturer_sku}
            name={product.name}
            path={product.path}
            publicPrice={product.price_and_stock?.price?.public_price}
            refetchCart={refetchCart}
            saleUnit={product.price_and_stock?.sale_unit}
            salesPackaging={product.price_and_stock?.sales_packaging}
            sku={product.sku}
            slug={product.slug}
            source={product.source}
            splitPackaging={product.price_and_stock?.split_packaging}
            stockStatus={product.price_and_stock?.stock_status}
            stocks={product.price_and_stock?.stocks}
            weeeAmount={product.price_and_stock?.price?.weee_amount}
          />
        </div>
      ))}
    </Slider>
  );
};

ProductSlider.defaultProps = {
  ...ProductSliderDefaultProps,
};

ProductSlider.propTypes = {
  ...ProductSliderPropTypes,
};

export default ProductSlider;
